import AuthService from '@src/services/AuthService'
import { useCallback, useEffect, useMemo } from 'react'
import { API } from '@src/network'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuthUserData } from '@src/data/Auth/selectors'
import { UpdateAuthUserData } from '@src/data/Auth/actions'
import { TypeOrNull } from '@src/models/Common'
import { IAuthData } from '@src/models/Auth'
import { ThunkDispatch } from 'redux-thunk'

export const isShiftPostingRedesignEnabledForUser = (user?: TypeOrNull<IAuthData>): boolean => {
  return Boolean(user?.show_new_shift_posting_redesign)
}

export const useIsShiftPostingRedesignEnabled = () => {
  const authData = useSelector(selectAuthUserData)
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const hasField = useMemo(
    () => authData && authData.hasOwnProperty('show_new_shift_posting_redesign'),
    [authData]
  )
  const fetchLoggedInUser = useCallback(async () => {
    const loggedInUser = AuthService.getLoggedInUser()
    if (loggedInUser && !hasField) {
      try {
        const response = await API.Auth.me()
        dispatch(UpdateAuthUserData(response.data))
        localStorage.setItem('loggedInUser', JSON.stringify(response.data))
      } catch (error) {}
    }
  }, [dispatch, hasField])

  useEffect(() => {
    fetchLoggedInUser()
  }, [fetchLoggedInUser])
}
